import React from 'react';

export const Amazon = ({ ...rest }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 315.001 315.001"
      {...rest}
    >
      <g id="XMLID_440_">
        <path
          id="XMLID_441_"
          d="M312.115,225.631c-4.978-6.107-19.688-6.768-25.781-6.768c-5.448,0-13.726,0.534-22.309,3.107
		c-5.574,1.748-10.528,4.182-15.08,7.392c-4.254,2.932-6.155,7.547-4.844,11.759c1.226,3.938,4.891,6.481,9.336,6.481
		c0.317,0,0.648-0.013,0.989-0.04c0.29-0.023,0.579-0.064,0.864-0.121c1.114-0.223,2.429-0.404,3.906-0.578
		c-31.41,11.719-65.365,17.898-98.508,17.898c-50.729,0-102.068-13.663-144.561-38.472c-0.06-0.034-0.12-0.069-0.181-0.102
		c-1.861-1.019-3.805-1.535-5.775-1.535c-4.401,0-8.169,2.603-9.601,6.631c-1.455,4.095-0.079,8.658,3.506,11.691
		c41.67,37.83,96.091,58.664,153.256,58.664c39.099,0,81.219-11.284,112.689-30.188c3.919-2.247,7.604-4.623,10.988-7.082
		c-1.186,3.255-2.647,7.035-4.44,11.426c-0.013,0.032-0.026,0.065-0.039,0.099c-1.306,3.331-1.012,6.77,0.806,9.435
		c1.714,2.513,4.621,4.014,7.774,4.014c2.518,0,5.023-0.908,7.247-2.625c0.087-0.068,0.173-0.138,0.258-0.209
		c15.821-13.377,22.053-36.628,22.381-48.992c0.002-0.066,0.003-0.133,0.003-0.199v-1.82c0-3.556-0.896-6.939-2.457-9.284
		C312.411,226.012,312.267,225.818,312.115,225.631z"
        />
        <path
          id="XMLID_443_"
          d="M237.691,86.918c0.136-19.574,0.275-39.815-16.405-55.39c-18.468-16.856-45.733-18.167-53.649-18.167
		h-6.699c-0.145,0-0.289,0.005-0.434,0.014c-39.62,2.293-65.941,22.382-72.247,55.125c-1.02,4.373,0.168,7.604,1.358,9.557
		c1.811,2.97,4.924,5.104,8.765,6.012c0.257,0.061,0.516,0.107,0.777,0.141l31.218,3.971c0.756,0.097,1.522,0.076,2.271-0.058
		c5.977-1.073,10.305-5.556,11.604-12.005c2.425-10.402,11.581-13.017,17.081-13.631h1.84c4.775,0,9.443,2.037,11.669,5.082
		c2.661,4.168,2.67,10.562,2.635,16.789c-5.537,0.443-11.534,0.975-17.547,1.77c-13.026,1.686-26.68,4.006-38.33,9.504
		c-24.844,10.172-39.085,31.82-39.085,59.43c0,17.705,5.624,32.463,16.264,42.677c9.932,9.534,23.504,14.573,39.25,14.573
		c8.77,0,16.619-0.953,24.705-3c0.139-0.035,0.276-0.074,0.412-0.117c9.569-3.015,17.935-8.031,26.916-16.287
		c3.313,4.63,6.814,8.906,14.604,15.454c0.615,0.517,1.31,0.932,2.057,1.229c5.454,2.167,10.982,1.568,15.121-1.577
		c0.09-0.068,0.179-0.139,0.266-0.211c6.936-5.781,18.458-15.68,24.672-21.303c5.152-4.319,5.996-11.306,2.135-17.871
		c-0.169-0.287-0.357-0.564-0.563-0.826l-1.208-1.531c-5.501-6.951-9.476-11.973-9.476-23.486v-50.33
		C237.666,90.594,237.678,88.748,237.691,86.918z M172.36,153.996c-0.095,0.158-0.183,0.32-0.265,0.484
		c-2.642,5.279-7.108,9.065-12.316,10.467c-0.735,0.072-1.407,0.2-2.023,0.317c-0.422,0.081-1.059,0.202-1.29,0.202
		c-10.877,0-12.051-11.179-12.051-15.984c0-12.105,5.683-19.186,18.422-22.935c4.12-0.947,9.006-1.566,14.588-1.852l0.003,1.764
		C177.461,137.454,177.485,145.399,172.36,153.996z"
        />
      </g>
    </svg>
  );
};

export const Google = ({ ...rest }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 315 315"
      {...rest}
    >
      <g id="XMLID_510_">
        <path
          id="XMLID_511_"
          d="M307.5,136.892h-19.791V117.1c0-4.143-3.357-7.5-7.5-7.5h-26.717c-4.143,0-7.5,3.357-7.5,7.5v19.792
		h-19.791c-4.143,0-7.5,3.357-7.5,7.5v26.717c0,4.143,3.357,7.5,7.5,7.5h19.791v19.792c0,4.142,3.357,7.5,7.5,7.5h26.717
		c4.143,0,7.5-3.358,7.5-7.5v-19.792H307.5c4.143,0,7.5-3.357,7.5-7.5v-26.717C315,140.249,311.643,136.892,307.5,136.892z"
        />
        <path
          id="XMLID_512_"
          d="M101.906,104.16c9.088,0,17.823,2.45,25.274,7.087l8.513,5.825c2.967,2.03,6.958,1.671,9.514-0.861
		l24.828-24.596c1.589-1.574,2.392-3.774,2.191-6.001c-0.2-2.227-1.384-4.248-3.228-5.513l-14.43-9.896
		c-0.294-0.201-0.603-0.382-0.922-0.539l-13.979-6.902c-0.185-0.092-0.374-0.176-0.566-0.252
		c-12.042-4.754-24.729-7.165-37.708-7.165c-26.757,0-51.996,10.27-71.068,28.915c-19.367,18.934-30.137,44.681-30.323,72.499
		c-0.187,27.824,10.239,53.72,29.355,72.916c18.968,19.049,45.879,29.975,73.834,29.975c27.658,0,53.608-10.739,71.195-29.463
		c13.931-14.831,22.48-34.641,24.727-57.288c0.021-0.215,0.034-0.43,0.036-0.645l0.26-20.345c0.006-0.421-0.024-0.841-0.09-1.257
		l-1.09-6.953c-0.571-3.649-3.716-6.339-7.409-6.339h-86.672c-4.143,0-7.5,3.358-7.5,7.5v29.982c0,4.142,3.357,7.5,7.5,7.5h44.186
		c-2.025,4.439-5.216,9.12-9.251,13.482c-8.801,9.518-21.926,14.977-36.01,14.977c-14.383,0-28.157-5.636-37.79-15.462
		c-20.052-20.448-19.822-56.077,0.489-76.245C75.334,109.605,88.505,104.16,101.906,104.16z"
        />
      </g>
    </svg>
  );
};

export const Facebook = ({ ...rest }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 310 310"
      {...rest}
    >
      <g id="XMLID_834_">
        <path
          id="XMLID_835_"
          d="M81.703,165.106h33.981V305c0,2.762,2.238,5,5,5h57.616c2.762,0,5-2.238,5-5V165.765h39.064
		c2.54,0,4.677-1.906,4.967-4.429l5.933-51.502c0.163-1.417-0.286-2.836-1.234-3.899c-0.949-1.064-2.307-1.673-3.732-1.673h-44.996
		V71.978c0-9.732,5.24-14.667,15.576-14.667c1.473,0,29.42,0,29.42,0c2.762,0,5-2.239,5-5V5.037c0-2.762-2.238-5-5-5h-40.545
		C187.467,0.023,186.832,0,185.896,0c-7.035,0-31.488,1.381-50.804,19.151c-21.402,19.692-18.427,43.27-17.716,47.358v37.752H81.703
		c-2.762,0-5,2.238-5,5v50.844C76.703,162.867,78.941,165.106,81.703,165.106z"
        />
      </g>
    </svg>
  );
};

export const Twitter = ({ ...rest }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 310 310"
      {...rest}
    >
      <g id="XMLID_826_">
        <path
          id="XMLID_827_"
          d="M302.973,57.388c-4.87,2.16-9.877,3.983-14.993,5.463c6.057-6.85,10.675-14.91,13.494-23.73
		c0.632-1.977-0.023-4.141-1.648-5.434c-1.623-1.294-3.878-1.449-5.665-0.39c-10.865,6.444-22.587,11.075-34.878,13.783
		c-12.381-12.098-29.197-18.983-46.581-18.983c-36.695,0-66.549,29.853-66.549,66.547c0,2.89,0.183,5.764,0.545,8.598
		C101.163,99.244,58.83,76.863,29.76,41.204c-1.036-1.271-2.632-1.956-4.266-1.825c-1.635,0.128-3.104,1.05-3.93,2.467
		c-5.896,10.117-9.013,21.688-9.013,33.461c0,16.035,5.725,31.249,15.838,43.137c-3.075-1.065-6.059-2.396-8.907-3.977
		c-1.529-0.851-3.395-0.838-4.914,0.033c-1.52,0.871-2.473,2.473-2.513,4.224c-0.007,0.295-0.007,0.59-0.007,0.889
		c0,23.935,12.882,45.484,32.577,57.229c-1.692-0.169-3.383-0.414-5.063-0.735c-1.732-0.331-3.513,0.276-4.681,1.597
		c-1.17,1.32-1.557,3.16-1.018,4.84c7.29,22.76,26.059,39.501,48.749,44.605c-18.819,11.787-40.34,17.961-62.932,17.961
		c-4.714,0-9.455-0.277-14.095-0.826c-2.305-0.274-4.509,1.087-5.294,3.279c-0.785,2.193,0.047,4.638,2.008,5.895
		c29.023,18.609,62.582,28.445,97.047,28.445c67.754,0,110.139-31.95,133.764-58.753c29.46-33.421,46.356-77.658,46.356-121.367
		c0-1.826-0.028-3.67-0.084-5.508c11.623-8.757,21.63-19.355,29.773-31.536c1.237-1.85,1.103-4.295-0.33-5.998
		C307.394,57.037,305.009,56.486,302.973,57.388z"
        />
      </g>
    </svg>
  );
};

export const Youtube = ({ ...rest }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 310 310"
      {...rest}
    >
      <g id="XMLID_822_">
        <path
          id="XMLID_823_"
          d="M297.917,64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359,0-61.369,5.776-72.517,19.938
		C0,79.663,0,100.008,0,128.166v53.669c0,54.551,12.896,82.248,83.386,82.248h143.226c34.216,0,53.176-4.788,65.442-16.527
		C304.633,235.518,310,215.863,310,181.835v-53.669C310,98.471,309.159,78.006,297.917,64.645z M199.021,162.41l-65.038,33.991
		c-1.454,0.76-3.044,1.137-4.632,1.137c-1.798,0-3.592-0.484-5.181-1.446c-2.992-1.813-4.819-5.056-4.819-8.554v-67.764
		c0-3.492,1.822-6.732,4.808-8.546c2.987-1.814,6.702-1.938,9.801-0.328l65.038,33.772c3.309,1.718,5.387,5.134,5.392,8.861
		C204.394,157.263,202.325,160.684,199.021,162.41z"
        />
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/vp-ui/components/SocialMediaElement/SocialMediaIcon.jsx